import qs from 'qs'
import { saveAs } from 'file-saver'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'
import moment from 'utils/moment'

export const getIncidentDashboardApi = ({
  is_significant,
  risk_level_id,
  impact_type_id,
  report_type_id,
  report_status_id,
  assignee_id,
  reporter_company_id,
  reporter_group_id,
  reporter_bu_id,
  reporter_division_id,
  reporter_department_id,
  reporter_section_id,
  risk_co_company_id,
  risk_co_group_id,
  risk_co_bu_id,
  risk_co_division_id,
  risk_co_department_id,
  risk_co_section_id,
  risk_owner_company_id,
  risk_owner_group_id,
  risk_owner_bu_id,
  risk_owner_division_id,
  risk_owner_department_id,
  risk_owner_section_id,
  date_from,
  date_to,
}) => {
  const params = removeEmpty({
    is_significant,
    risk_level_id,
    impact_type_id,
    report_type_id,
    report_status_id,
    assignee_id,
    reporter_company_id,
    reporter_group_id,
    reporter_bu_id,
    reporter_division_id,
    reporter_department_id,
    reporter_section_id,
    risk_co_company_id,
    risk_co_group_id,
    risk_co_bu_id,
    risk_co_division_id,
    risk_co_department_id,
    risk_co_section_id,
    risk_owner_company_id,
    risk_owner_group_id,
    risk_owner_bu_id,
    risk_owner_division_id,
    risk_owner_department_id,
    risk_owner_section_id,
    date_from,
    date_to,
  })

  const config = {
    method: 'get',
    url: '/api/v1/incident/dashboard',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({
          data: res.data,
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getIncidentApi = ({
  page,
  size,
  incident_topic,
  reporter,
  risk_co,
  risk_owner,
  date_from,
  date_to,
  report_status_id,
  ...param
}) => {
  const params = removeEmpty({
    ...param,
    page,
    size,
    incident_topic,
    reporter,
    risk_co,
    risk_owner,
    date_from,
    date_to,
    report_status_id,
  })

  const config = {
    method: 'get',
    url: '/api/v1/incident/',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: res.data?.items,
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getDefaultDescriptionApi = (report_header_id) => {
  const config = {
    method: 'get',
    url: `/api/v1/incident/default_description_by_incident_id/${report_header_id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.status == 200) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const exportIncidentApi = (
  {
    incident_topic,
    reporter,
    risk_co,
    risk_owner,
    date_from,
    date_to,
    report_status_id,

    ...param
  },
  file
) => {
  const bodyFormData = new FormData()
  bodyFormData.append('file', file)
  const params = removeEmpty({
    ...param,
    incident_topic,
    reporter,
    risk_co,
    risk_owner,
    date_from,
    date_to,
    report_status_id,
  })

  const config = {
    method: 'post',
    url: '/api/v1/incident/export_incident',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
    data: bodyFormData,
    responseType: 'blob',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      const { status } = res
      if (status !== 200) {
        return responseError({ message: 'API something went wrong' })
      }
      if (res?.data) {
        saveFileFromResponse(res)
      }
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const saveFileFromResponse = (response) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))

  const filename = `operational_loss_and_appetite_${moment().format('YYYYMMDD')}_${moment().format(
    'hhmmss'
  )}.xlsx`

  saveAs(downloadUrl, filename)
}
